import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'info-menu',
  templateUrl: 'info-menu.component.html',
  styleUrls: ['../admin-menu/admin-menu.component.scss'],
})
export class InfoMenuComponent { }
